import DashboardLayout from "./DashboardLayout";
import socket from '../socket.js'
import {useState,useEffect} from 'react'

function Dashboard() {

  


    return (

        <DashboardLayout>

            <div className="
                bg-slate-900
                rounded-3xl
                border
                border-slate-800
                h-[600px]
                flex
                items-center
                justify-center
            ">

                <h2 className="
                    text-4xl
                    text-cyan-400
                    font-bold
                ">

                    داشبورد MegaGames

                </h2>

            </div>

        </DashboardLayout>

    );

}

export default Dashboard;
